import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  CompareQuotesTableWrap,
  CurrentQuoteTableBox,
} from "./CompareQuoteStyled";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  BUNDLEVALIDATIONSTATUS,
  Constants,
  DISCOUNTMODE,
  DialogConstants,
} from "./Content";
import { AccountDataRevenueCard } from "./AccountDataInfoCard";
import { Link } from "react-router-dom";
import BundleActions from "./BundleActions";
import { useDispatch } from "react-redux";
import {
  approveBundle,
  calculateBundleDiscount,
  duplicateBundle,
  getBundleNotes,
  getBundleUploadDataByBundleId,
  refreshBundle,
  removeBundle,
  saveBundleName,
  saveBundleNote,
  saveBundleStatus,
  saveCrmBundleId,
  submitBundle,
  validateBundle,
} from "../../Actions/QuoteAction";
import { Congiguration } from "../../Constants/AppConstants";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Severity } from "../utilities/Notification/NotificationContent";
import checkIcon from "../../images/checkIcon.svg";
import ConfirmationDialog from "../utilities/Dialog/Confirmation";
import { addBundledProduct } from "../../Actions/CRMAction";
import BundleOpportunityDetails from "./BundleOpportunityDetails";
import OkayDialog from "../utilities/Dialog/SimpleOkayDialog";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import moment from "moment";
import { statusColors } from "./Data";
import ViewVisualizationBundleNotesDialog from "./ViewBundleNotesDialog";
import AddVisualizationBundleNoteDialog from "./AddVisualizationBundleNotesDialog";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import FilledInput from "@mui/material/FilledInput";
import ClearIcon from "@mui/icons-material/Clear";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Grid from "@mui/material/Grid";
import { set } from "lodash";

const BundleOptionAccordian = ({
  quoteHeaders,
  quotesToBndle,
  loggedUser,
  bundleRevenue,
  removeQuotes,
  showNotification,
  opportunityDetails = [],
  isManageBundle = false,
  bundleAccordianHeaders,
}) => {
  const dispatch = useDispatch();
  const [bundleArray, setBundleArray] = useState(quotesToBndle);
  const [bundleRevenueData, setBundleRevenueData] = useState(
    bundleRevenue ? bundleRevenue : [],
  );
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("");
  const [removeBundleDetails, setRemoveBundleDetails] = useState(null);
  const [duplicateBundleDetails, setDuplicateBundleDetails] = useState(null);
  const [
    currentBundleDetailsForDuplicateValidation,
    setcurrentBundleDetailsForDuplicateValidation,
  ] = useState(null);
  const [showDialogBox, setShowDialogBox] = useState(false);
  const [showDuplicateDialogBox, setShowDuplicateDialogBox] = useState(false);
  const [expanded, setExpanded] = React.useState("");
  const [showBundleNotesDialog, setShowBundleNotesDialog] = useState(false);
  const [showAddBundleNotes, setShowAddBundleNotes] = useState(false);
  const [isReject, setIsReject] = useState(false);
  const [noteText, setNoteText] = useState("");
  const [currentBundleIdForAddNotes, setCurrentBundleIdForAddNotes] =
    useState(null);
  const [currentBundleIdForViewNotes, setCurrentBundleIdForViewNotes] =
    useState(null);
  const [approvalInProgress, setApprovalInProgress] = useState(false);
  const [isEditBundleName, setIsEditBundleName] = useState(false);
  const [
    currentBundleIdForEditBundleName,
    setCurrentBundleIdForEditBundleName,
  ] = useState(null);
  const [newBundleName, setNewBundleName] = useState("");

  const handleAddBundleNote = () => {
    if (currentBundleIdForAddNotes && currentBundleIdForAddNotes !== null) {
      if (noteText) {
        let newNote = {
          bundleId: currentBundleIdForAddNotes,
          message: noteText,
          isReject: isReject,
          userId: loggedUser?.user?.id,
        };
        saveNote(newNote);
      }
    }
  };

  const saveNote = (bundleNote) => {
    if (bundleNote && bundleNote !== null) {
      dispatch(saveBundleNote(bundleNote))
        .then((res) => {
          if (res === 1) {
            setNoteText("");
            getBundleNoteList(bundleNote.bundleId);
            CloseAddBundleNotesDialog();
            showNotification(
              Severity.SUCCESS,
              Constants.DIALOG_MESSAGE_NOTEADDSUCCESS,
            );
          } else {
            showNotification(
              Severity.ERROR,
              Constants.DIALOG_MESSAGE_NOTEADDERROR,
            );
          }
        })
        .catch((e) => {
          console.log(e);
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG,
          );
        });
    }
  };

  const getBundleNoteList = (bundleId) => {
    setLoading(true);
    if (bundleId && bundleId !== null) {
      dispatch(getBundleNotes(bundleId))
        .then((res) => {
          setLoading(false);
          if (res && res !== null) {
            updateBundleNotes(...[res], bundleId);
          }
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
        });
    }
  };

  const updateBundleNotes = (notes, bundleId) => {
    let existingBundleArray = [...bundleArray];
    let bundleObj = existingBundleArray.find(
      (b) => b[0]?.bundleDetails?.bundleId === bundleId,
    );
    let bundleObjIndex = existingBundleArray.findIndex(
      (b) => b[0]?.bundleDetails?.bundleId === bundleId,
    );
    if (bundleObj) {
      bundleObj.map((quote) => {
        quote.bundleDetails.notes = [...notes];
      });
      existingBundleArray.splice(bundleObjIndex, 1, bundleObj);
    }
    setBundleArray(existingBundleArray);
  };

  const handleViewBundleNotes = (event, bundleId) => {
    if (bundleId && bundleId !== null) {
      OpenBundleNotesDialog();
      getBundleNoteList(bundleId);
    }
  };

  const OpenBundleNotesDialog = () => {
    setShowBundleNotesDialog(true);
  };
  const CloseBundleNotesDialog = () => {
    setShowBundleNotesDialog(false);
  };
  const OpenAddBundleNotesDialog = () => {
    setShowAddBundleNotes(true);
  };
  const CloseAddBundleNotesDialog = () => {
    setShowAddBundleNotes(false);
  };

  const handleNotesTextChange = (value) => {
    if (value) {
      setNoteText(value);
    } else {
      setNoteText("");
    }
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const closeDialogBox = () => {
    setShowDialogBox(false);
  };

  const openDialogBox = () => {
    setShowDialogBox(true);
  };

  const openDuplicateDialogBox = () => {
    setShowDuplicateDialogBox(true);
  };

  const closeDuplicateDialogBox = () => {
    setShowDuplicateDialogBox(false);
  };

  useEffect(() => {
    setBundleArray(quotesToBndle);
  }, [quotesToBndle]);

  useEffect(() => {
    setBundleRevenueData(bundleRevenue);
  }, [bundleRevenue]);

  const calculateDiscountOnBundle = (
    discountMode,
    discountValue,
    bundleId,
    rateSum,
    bundleIndex,
  ) => {
    let discount = discountValue;
    if (discountMode === DISCOUNTMODE.VALUE) {
      discount = (discountValue / rateSum) * 100;
    }
    const calculateBundleParams = {
      bundleId: bundleId,
      discount: discount,
      companyId: Congiguration.CompanyId,
      userId: loggedUser?.user?.id,
    };
    setLoading(true);
    setLoadingText("Calculating...");
    dispatch(calculateBundleDiscount(calculateBundleParams))
      .then((data) => {
        setLoading(false);
        setLoadingText("");
        updateBundleByIndex(data, bundleIndex);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setLoadingText("");
      });
  };

  const handleRefreshBundle = (bundleId, bundleIndex) => {
    if (bundleId && bundleId !== null) {
      const refreshBundleObj = {
        bundleId: bundleId,
        userId: loggedUser?.user?.id,
      };
      setLoading(true);
      setLoadingText("Getting bundle details...");
      dispatch(refreshBundle(refreshBundleObj))
        .then((data) => {
          setLoading(false);
          setLoadingText("");
          updateBundleByIndex(data, bundleIndex);
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
          setLoadingText("");
        });
    }
  };

  const handleRemoveBundle = (bundleId, index) => {
    const removeBundleDetailsObj = { bundleId: bundleId, index: index };
    setRemoveBundleDetails(removeBundleDetailsObj);
    openDialogBox();
  };

  const handleOkayToDuplicateQuotesInBundle = () => {
    if (duplicateBundleDetails && duplicateBundleDetails !== null) {
      dispatch(duplicateBundle(duplicateBundleDetails))
        .then((res) => {
          if (res == 1) {
            startBundleApprovalProcess(
              currentBundleDetailsForDuplicateValidation.bundleId,
              currentBundleDetailsForDuplicateValidation.discount,
              currentBundleDetailsForDuplicateValidation.discountMode,
              currentBundleDetailsForDuplicateValidation.rateTotal,
              currentBundleDetailsForDuplicateValidation.index,
            );
            closeDuplicateDialogBox();
          } else {
            showNotification(
              Severity.ERROR,
              Constants.MESSAGE_SOMETHINGWENTWRONG_DUPLICATE,
            );
            closeDuplicateDialogBox();
          }
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
          setLoadingText("");
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG,
          );
          closeDuplicateDialogBox();
        });
    }
  };

  const removeBundleByIdAndIndex = () => {
    const bundleId = removeBundleDetails?.bundleId;
    const index = removeBundleDetails?.index;
    closeDialogBox();
    if (bundleId && bundleId !== null) {
      const removeBundleParams = {
        bundleId: bundleId,
        userId: loggedUser?.user?.id,
      };
      setLoading(true);
      setLoadingText("Getting bundle details...");
      dispatch(removeBundle(removeBundleParams))
        .then((data) => {
          setLoading(false);
          setLoadingText("");
          removeQuotes(index);
          showNotification(
            Severity.SUCCESS,
            Constants.MESSAGE_BUNDLEREMOVESUCCESS,
          );
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
          setLoadingText("");
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG,
          );
          closeDialogBox();
        });
    } else
      showNotification(Severity.ERROR, Constants.MESSAGE_SOMETHINGWENTWRONG);
  };

  const updateBundleByIndex = (data, index) => {
    let rateSum = data?.quotesForBundleDatas.reduce(
      (accumulator, currentValue) =>
        accumulator + currentValue?.rateReqCurrency,
      0,
    );
    let rateSumUsd = data?.quotesForBundleDatas.reduce(
      (accumulator, currentValue) => accumulator + currentValue?.rateUSD,
      0,
    );
    
    let existingBundleArray = [...bundleArray];
    
    data.bundleDetails.bundleNameOnly = data?.bundleDetails?.bundleName;
    const bundleName = data?.bundleDetails?.bundleNameByUser
    ? data?.bundleDetails?.bundleName +
    "-" +
    data?.bundleDetails?.bundleNameByUser
    : data?.bundleDetails?.bundleName;
    
    data.bundleDetails.bundleName = bundleName;
    
    data?.quotesForBundleDatas.map((quote) => {
        quote.rateReqCurrencySum = rateSum;
        quote.rateUsdSum = rateSumUsd;
        quote.bundleDetails = data?.bundleDetails;
    });
    
    const discountedQuotes = [...data?.quotesForBundleDatas];
    
    existingBundleArray.splice(index, 1, discountedQuotes);
    existingBundleArray[0]?.forEach((bundle) => {
        bundle.totalTcvCad = data?.quotesForBundleRevenueDatas[0]?.tcvcad;
    });
    setBundleArray(existingBundleArray);
    setBundleRevenueData([...data?.quotesForBundleRevenueDatas]);
  };

  const startBundleApprovalProcess = (
    bundleId,
    discount,
    discountMode,
    rateTotal,
    index,
  ) => {
    const currentBundleValidationObj = {
      bundleId: bundleId,
      discount: discount,
      discountMode: discountMode,
      rateTotal: rateTotal,
      indx: index,
    };
    setcurrentBundleDetailsForDuplicateValidation(currentBundleValidationObj);
    if (bundleId && bundleId !== null && bundleId !== "") {
      setLoading(true);
      setLoadingText("Approving bundle..");
      dispatch(validateBundle(bundleId))
        .then((validationStatus) => {
          if (validationStatus && validationStatus !== null) {
            const discountPercent =
              discountMode === DISCOUNTMODE.PERCENT
                ? discount
                : (discount / rateTotal) * 100;
            const discountValue =
              discountMode === DISCOUNTMODE.VALUE ? discount : null;

            //const discountPercent = discountMode === DISCOUNTMODE.PERCENT ? discount : ((discount / rateTotal) * 100);
            //const discountValue = discountMode === DISCOUNTMODE.VALUE ? discount : null;

            if (
              validationStatus?.validationCode ===
              BUNDLEVALIDATIONSTATUS.VALIDATION_FAILURE_QUOTES_ALREADY_APPROVED
                .Code
            ) {
              //Duplicate
              setDuplicateBundleDetails({
                bundleId: bundleId,
                discountPercent: discountPercent,
                discountValue: discountValue,
                userId: loggedUser?.user?.id,
                companyId: Congiguration.CompanyId,
              });
              openDuplicateDialogBox();
            } else if (
              validationStatus?.validationCode ===
                BUNDLEVALIDATIONSTATUS.VALIDATION_SUCCESS_APPROVE.Code &&
              (discount === "" || discount === null || discount === 0)
            ) {
              //Approve and Add to CRM
              //handleRefreshBundle(bundleId[0], index);
              const approveBundleObj = {
                bundleId: bundleId,
                discountPercent: discountPercent,
                discountValue: discountValue,
                userId: loggedUser?.user?.id,
                companyId: Congiguration.CompanyId,
              };
              setApprovalInProgress(true);
              approveTheBundle(approveBundleObj);
              handleRefreshBundle(bundleId, index);
              GetBundledProductDetailsAndAddToCrm(bundleId);
            } else if (
              validationStatus?.validationCode ===
                BUNDLEVALIDATIONSTATUS.VALIDATION_SUCCESS_APPROVE.Code &&
              discount !== "" &&
              discount !== null &&
              discount !== 0
            ) {
              //Assign to pricing team
              const approveBundleObj = {
                bundleId: bundleId,
                discountPercent: discountPercent,
                discountValue: discountValue,
                userId: loggedUser?.user?.id,
                companyId: Congiguration.CompanyId,
              };
              setApprovalInProgress(true);
              approveTheBundle(approveBundleObj);
              handleRefreshBundle(bundleId, index);
              showNotification(
                Severity.SUCCESS,
                Constants.MESSAGE_BUNDLESUBMITTED_TOPRICINGTEAM,
              );
            } else {
              let result = null;
              Object.keys(BUNDLEVALIDATIONSTATUS).forEach((status) => {
                if (
                  BUNDLEVALIDATIONSTATUS[status]?.Code ===
                  validationStatus?.validationCode
                ) {
                  result = BUNDLEVALIDATIONSTATUS[status];
                }
              });
              if (result && result !== null)
                showNotification(Severity.ERROR, result.Message);
              else
                showNotification(
                  Severity.ERROR,
                  Constants.MESSAGE_SOMETHINGWENTWRONG,
                );
            }
          }
          setLoading(false);
          setLoadingText("");
        })
        .catch((e) => {
          console.log(e);
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG,
          );
        });
    }
  };

  const approveTheBundle = (approveBundleObj, bundleIndex) => {
    if (approveBundleObj && approveBundleObj !== null) {
      dispatch(approveBundle(approveBundleObj))
        .then((res) => {
          setApprovalInProgress(false);
          if (res === 1) {
            removeQuotes(bundleIndex);
            showNotification(
              Severity.SUCCESS,
              Constants.MESSAGE_BUNDLEAPPROVED,
            );
          } else if (res === 0) {
            showNotification(
              Severity.ERROR,
              Constants.MESSAGE_BUNDLEAPPROVEDERROR,
            );
          }
        })
        .catch((e) => {
          console.log(e);
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_BUNDLEAPPROVEDERROR,
          );
        });
    }
  };

  const handleSubmitBundle = (submitBundleObj, bundleIndex) => {
    if (submitBundleObj && submitBundleObj !== null) {
      setLoading(true);
      setLoadingText("Submitting bundle...");
      setApprovalInProgress(true);
      dispatch(submitBundle(submitBundleObj))
        .then((res) => {
          if (res === 1) {
            removeQuotes(bundleIndex);
            showNotification(
              Severity.SUCCESS,
              Constants.MESSAGE_BUNDLESUBMITTED,
            );
            setApprovalInProgress(false);
            setLoading(false);
            setLoadingText("");
          } else if (res === 0) {
            showNotification(
              Severity.ERROR,
              Constants.MESSAGE_BUNDLESUBMITTEDERROR,
            );
            setApprovalInProgress(false);
            setLoading(false);
            setLoadingText("");
          }
        })
        .catch((e) => {
          console.log(e);
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG,
          );
          setApprovalInProgress(false);
          setLoading(false);
          setLoadingText("");
        });
    }
  };

  const GetBundledProductDetailsAndAddToCrm = (bundleId) => {
    if (bundleId && bundleId !== null) {
      dispatch(getBundleUploadDataByBundleId(bundleId))
        .then((data) => {
          const bundleObj = PrepareCrmBundleObject(data);
          AddBundleToCRM(bundleObj, bundleId);
        })
        .catch((e) => {
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG,
          );
          console.log(e);
        });
    }
  };

  const AddBundleToCRM = (bundleObj, bundleId) => {
    if (bundleObj && bundleObj !== null) {
      dispatch(addBundledProduct(bundleObj))
        .then((data) => {
          saveCrmBundleIdInCpq({
            bundleId: bundleId,
            crmBundleId: data?.crMbundleId,
          });
          showNotification(
            Severity.SUCCESS,
            Constants.MESSAGE_BUNDLEADDTOCRMUCCESS,
          );
        })
        .catch((e) => {
          console.log(e);
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG_ADDBUNDLETOCRM,
          );
        });
    }
  };

  const saveCrmBundleIdInCpq = (saveCrmBundleIdObj) => {
    if (saveCrmBundleIdObj && saveCrmBundleIdObj !== null) {
      dispatch(saveCrmBundleId(saveCrmBundleIdObj))
        .then((res) => {
          console.log("save crm bundle id", res);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const PrepareCrmBundleObject = (bundleData) => {
    const quotes = bundleData?.crmBundleQuotes?.map((quote) => {
      return {
        opportunitId: quote?.crmBundleQuote?.oppurtunityId,
        productId: quote?.crmBundleQuote?.crmProductId,
        session: quote?.crmBundleQuote?.sessions,
        hours: quote?.crmBundleQuote?.hours,
        utilization: quote?.crmBundleQuote?.utilization,
        rate: quote?.crmBundleQuote?.rate,
        pricingStrucutre: `${quote?.crmBundleQuote?.pricingStructureCode}`,
        quoteId: quote?.crmBundleQuote?.quoteId,
        currencyId: quote?.crmBundleQuote?.currencyCode,
        seatCount: quote?.crmBundleQuote?.seatCount,
        populations: quote?.crmQuoteCountryHeadCounts?.map((population) => {
          return {
            countryId: population?.crmCountryId,
            country: population?.countryName,
            headCount: population?.headcount,
            region: population?.region,
          };
        }),
        componentList: quote?.crmQuoteComponents?.map((component) => {
          return {
            name: component?.componentName,
            componentId: component?.crmComponentId,
          };
        }),
      };
    });

    const bundleObj = {
      opportunitId: bundleData?.bundleDetails?.oppurtunityId,
      cpQbundleId: bundleData?.bundleDetails?.bundleId,
      rate: bundleData?.bundleDetails?.rate,
      productId: bundleData?.bundleDetails?.crmProductId,
      currencyId: bundleData?.bundleDetails?.currencyCode,
      pricingStrucutre: `${bundleData?.bundleDetails?.pricingStructureCode}`,
      bundleQuotes: quotes,
    };

    return bundleObj;
  };
  const viewQuoteClick = (quoteId) => {
    sessionStorage.setItem("quoteIdFromVisualize", quoteId);
    window.open(`/viewquote`, "_blank").focus();
  };

  const updateBundleName = (bundleId, bundleName) => {
    let existingBundleArray = [...bundleArray];
    let bundleObj = existingBundleArray.find(
      (b) => b[0]?.bundleDetails?.bundleId === bundleId,
    );
    let bundleObjIndex = existingBundleArray.findIndex(
      (b) => b[0]?.bundleDetails?.bundleId === bundleId,
    );
    if (bundleObj) {
      bundleObj.map((quote) => {
        quote.bundleDetails.bundleNameByUser = bundleName;
        quote.bundleDetails.bundleName = bundleName
          ? quote.bundleDetails.bundleNameOnly + "-" + bundleName
          : quote.bundleDetails.bundleNameOnly;
      });
      existingBundleArray.splice(bundleObjIndex, 1, bundleObj);
    }
    setBundleArray(existingBundleArray);
  };

  const handleEditBundle = (event, bundleId, bundleNameByUser) => {
    setNewBundleName(bundleNameByUser);
    setIsEditBundleName(true);
    setCurrentBundleIdForEditBundleName(bundleId);
  };

  const handleCancelEditBundleName = () => {
    setNewBundleName("");
    setIsEditBundleName(false);
    setCurrentBundleIdForEditBundleName(null);
  };

  const handleSaveBundleName = (event) => {
    saveOrUpdateBundleName();
    setIsEditBundleName(false);
    setCurrentBundleIdForEditBundleName(null);
  };

  const onBundleNameTextChange = (event) => {
    const newBundleName = event.target.value;
    console.log("newBundleName", newBundleName);
    setNewBundleName(newBundleName);
  };

  const saveOrUpdateBundleName = () => {
    if (
      currentBundleIdForEditBundleName &&
      currentBundleIdForEditBundleName !== null &&
      newBundleName !== undefined &&
      newBundleName !== null
    ) {
      const saveUpdateBundleNameObj = {
        bundleId: currentBundleIdForEditBundleName,
        bundleName: newBundleName,
        userId: loggedUser?.user?.id,
      };
      dispatch(saveBundleName(saveUpdateBundleNameObj))
        .then((res) => {
          if (res === 1) {
            updateBundleName(currentBundleIdForEditBundleName, newBundleName);
            showNotification(
              Severity.SUCCESS,
              Constants.MESSAGE_SAVEUPDATEBUNDLENAMESUCCESS,
            );
          } else {
            showNotification(
              Severity.ERROR,
              Constants.MESSAGE_SAVEUPDATEBUNDLENAMEERROR,
            );
          }
        })
        .catch((e) => {
          console.log(e);
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG,
          );
        });
    }
  };

  const getBundleAccordianHeader = (bundledQuotes, index) => {
    return (
      <Table>
        <TableRow>
          <TableCell>
            {isEditBundleName &&
            currentBundleIdForEditBundleName ===
              bundledQuotes[0]?.bundleDetails?.bundleId ? (
              <>
                <FormControl
                  sx={{ display: "inline-flex", m: 1, width: "25ch" }}
                  variant="filled"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  title={bundledQuotes[0]?.bundleDetails?.bundleName}
                >
                  <FilledInput
                    //className="txtDiscount"
                    id="filled-adornment-weight"
                    startAdornment={
                      <InputAdornment position="start">
                        {bundledQuotes[0]?.bundleDetails?.bundleNameOnly + "-"}
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <Grid container>
                          <Grid item>
                            <CheckOutlinedIcon
                              sx={{
                                color: "rgb(35, 145, 85)",
                                "&:hover": {
                                  backgroundColor: "lightGray",
                                  cursor: "pointer",
                                },
                              }}
                              fontSize="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSaveBundleName(
                                  e,
                                  bundledQuotes[0]?.bundleDetails?.bundleId,
                                );
                              }}
                            />
                          </Grid>
                          <Grid item>
                            <ClearIcon
                              sx={{
                                "&:hover": {
                                  cursor: "pointer",
                                  backgroundColor: "lightGray",
                                },
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCancelEditBundleName();
                              }}
                              fontSize="small"
                            />
                          </Grid>
                        </Grid>
                      </InputAdornment>
                    }
                    aria-describedby="filled-weight-helper-text"
                    inputProps={{
                      "aria-label": "weight",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    value={newBundleName}
                    onChange={onBundleNameTextChange}
                    autoFocus={true}
                  />
                </FormControl>
              </>
            ) : (
              <>
                <span>
                  <strong>
                    {`Bundle ${index + 1} - ${bundledQuotes[0]?.bundleDetails?.bundleName} `}
                  </strong>
                </span>
                <BorderColorOutlinedIcon
                  sx={{
                    color: "#1b4a83",
                    "&:hover": {
                      borderColor: "#1b4a83",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditBundle(
                      e,
                      bundledQuotes[0]?.bundleDetails?.bundleId,
                      bundledQuotes[0]?.bundleDetails?.bundleNameByUser,
                    );
                  }}
                />
              </>
            )}
          </TableCell>
        </TableRow>
      </Table>
    );
  };

  const getFormattedCell = (key, quote) => {
    switch (quoteHeaders[key]) {
      case quoteHeaders?.productName:
        {
          return (
            <Link
              onClick={() => viewQuoteClick(quote?.quoteId)}
              className="viewLink"
            >
              {quote[key]}
            </Link>
          );
        }
        break;
      default:
        {
          return quote[key]?.toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          });
        }
        break;
    }
  };

  const getCellBGColor = (key) => {
    return quoteHeaders[key] === quoteHeaders?.rateReqCurrency
      ? "lightgray"
      : "none";
  };
  const getCellTextColor = (key, quote) => {
    return quoteHeaders[key] === quoteHeaders?.statusName
      ? getStatusColor(quote[key])
      : "none";
  };

  const getStatusColor = (status) => {
    return statusColors?.[status];
  };

  const getBundleNoteComponent = () => {
    let existingBundleArray = [...bundleArray];
    let bundleObj = existingBundleArray.find(
      (b) => b[0]?.bundleDetails?.bundleId === currentBundleIdForViewNotes,
    );
    const notes = bundleObj[0].bundleDetails?.notes ?? [];
    return (
      <ViewVisualizationBundleNotesDialog
        notes={notes}
        handleClose={CloseBundleNotesDialog}
        title={Constants.NOTESTITLE}
        show={showBundleNotesDialog}
      />
    );
  };

  return (
    <>
      {bundleArray?.map((bundledQuotes, index) => (
        <>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#1b4a83" }} />}
              aria-controls="panel1-content"
              id="panel1-header"
              className="bundleTableBoxHead"
            >
              {getBundleAccordianHeader(bundledQuotes, index)}

              <div className="bundleButtonsWrapper">
                <Button
                  variant="text"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentBundleIdForAddNotes(
                      bundledQuotes[0]?.bundleDetails?.bundleId,
                    );
                    OpenAddBundleNotesDialog();
                  }}
                >
                  Add Note
                  <AddCircleOutlineOutlinedIcon />
                </Button>
                <Button
                  variant="text"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentBundleIdForViewNotes(
                      bundledQuotes[0]?.bundleDetails?.bundleId,
                    );
                    handleViewBundleNotes(
                      e,
                      bundledQuotes[0]?.bundleDetails?.bundleId,
                    );
                  }}
                >
                  View Note(s)
                  <VisibilityOutlinedIcon />
                </Button>
                <Button
                  variant="text"
                  className="btnRefresh"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRefreshBundle(
                      bundledQuotes[0]?.bundleDetails?.bundleId,
                      index,
                    );
                  }}
                >
                  <RefreshIcon /> {Constants?.REFRESH}
                </Button>

                <Button
                  variant="text"
                  className="removeButton"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveBundle(
                      bundledQuotes[0]?.bundleDetails?.bundleId,
                      index,
                    );
                  }}
                >
                  <DeleteIcon sx={{ color: "#A62632" }} />
                  Remove
                </Button>
              </div>
            </AccordionSummary>

            <BundleActions
              bundleId={bundledQuotes[0]?.bundleDetails?.bundleId}
              handlePreviewDiscount={calculateDiscountOnBundle}
              handleApproveBundle={startBundleApprovalProcess}
              handleSubmitBundle={handleSubmitBundle}
              rateSum={bundledQuotes[0]?.rateReqCurrencySum}
              bundleArrayIndex={index}
              showNotification={showNotification}
              loggedUser={loggedUser}
              canSubmit={bundledQuotes[0]?.canSubmit}
              isManageBundle={isManageBundle}
              approvalInProgress={approvalInProgress}
            />
            <AccordionDetails>
              <CurrentQuoteTableBox>
                <CompareQuotesTableWrap component={Paper}>
                  <Box className="tableContainer">
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          {Object.keys(quoteHeaders)?.map((key) => (
                            <TableCell>{quoteHeaders[key]}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {bundledQuotes?.map((quote) => (
                          <TableRow>
                            {Object.keys(quoteHeaders)?.map((key) => (
                              <TableCell
                                style={{
                                  backgroundColor: getCellBGColor(key),
                                  color: getCellTextColor(key, quote),
                                }}
                              >
                                {getFormattedCell(key, quote)}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                        <TableRow className="totalRow">
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell
                            sx={{
                              fontWeight: 600,
                              textAlign: "center",
                              color: "#1b4a83",
                            }}
                          >
                            Total
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {bundleArray[
                              index
                            ][0]?.rateReqCurrencySum?.toLocaleString("en", {
                              useGrouping: true,
                              roundingMode: "trunc",
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            })}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {bundleArray[index][0].currencyCode}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {bundleArray[index][0]?.rateUsdSum?.toLocaleString(
                              "en",
                              {
                                useGrouping: true,
                                roundingMode: "trunc",
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                              },
                            )}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {bundleArray[
                              index
                            ][0]?.totalTcvCad?.toLocaleString("en", {
                              useGrouping: true,
                              roundingMode: "trunc",
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            })}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {bundleArray[index][0]?.pricingStructureName}
                          </TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </CompareQuotesTableWrap>
              </CurrentQuoteTableBox>

              {isManageBundle ? (
                <Box className="accountDataBox">
                  <AccountDataRevenueCard
                    data={` ${
                      bundledQuotes?.[0]?.bundleRevenue?.totalRevenueIncCom
                        ? `
                          ${
                            bundledQuotes?.[0]?.currencyCode
                          } ${bundledQuotes?.[0]?.bundleRevenue?.totalRevenueIncCom?.toLocaleString(
                            "en",
                            {
                              useGrouping: true,
                              roundingMode: "trunc",
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            },
                          )}`
                        : bundledQuotes?.[0]?.currencyCode + " 0.00"
                    }`}
                    header={"Total revenue"}
                    subheader={"(Incl. commission)"}
                  />
                  <AccountDataRevenueCard
                    data={`${
                      bundledQuotes?.[0]?.bundleRevenue?.annualRevenueWOCom
                        ? `
                        ${bundledQuotes?.[0]?.currencyCode} 
                        ${bundledQuotes?.[0]?.bundleRevenue?.annualRevenueWOCom?.toLocaleString(
                          "en",
                          {
                            useGrouping: true,
                            roundingMode: "trunc",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          },
                        )}`
                        : bundledQuotes?.[0]?.currencyCode + " 0.00"
                    }`}
                    header={"Annual revenue for WPO"}
                    subheader={"(W/o commission)"}
                  />
                  <AccountDataRevenueCard
                    data={`${
                      bundledQuotes?.[0]?.bundleRevenue?.totalRevenueIncComUSD
                        ? `USD ${bundledQuotes?.[0]?.bundleRevenue?.totalRevenueIncComUSD?.toLocaleString(
                            "en",
                            {
                              useGrouping: true,
                              roundingMode: "trunc",
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            },
                          )}`
                        : "USD 0.00"
                    }`}
                    header={"USD Total revenue"}
                    subheader={"(Incl. commission)"}
                  />
                  <AccountDataRevenueCard
                    data={`${
                      bundledQuotes?.[0]?.bundleRevenue?.annualRevenueWOComUSD
                        ? `
                          USD ${bundledQuotes?.[0]?.bundleRevenue?.annualRevenueWOComUSD?.toLocaleString(
                            "en",
                            {
                              useGrouping: true,
                              roundingMode: "trunc",
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            },
                          )}`
                        : "USD 0.00"
                    }`}
                    header={"USD Annual revenue for WPO"}
                    subheader={"(W/o commission)"}
                  />
                </Box>
              ) : (
                <Box className="accountDataBox">
                  <AccountDataRevenueCard
                    data={` ${
                      bundleRevenueData[index]?.totalRevenueIncCom
                        ? `
                          ${
                            bundledQuotes?.[0]?.currencyCode
                          } ${bundleRevenueData[
                            index
                          ]?.totalRevenueIncCom?.toLocaleString("en", {
                            useGrouping: true,
                            roundingMode: "trunc",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          })}`
                        : bundledQuotes?.[0]?.currencyCode + " 0.00"
                    }`}
                    header={"Total revenue"}
                    subheader={"(Incl. commission)"}
                  />
                  <AccountDataRevenueCard
                    data={`${
                      bundleRevenueData[index]?.annualRevenueWOCom
                        ? `
                        ${bundledQuotes?.[0]?.currencyCode} ${bundleRevenueData[
                          index
                        ]?.annualRevenueWOCom?.toLocaleString("en", {
                          useGrouping: true,
                          roundingMode: "trunc",
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })}`
                        : bundledQuotes?.[0]?.currencyCode + " 0.00"
                    }`}
                    header={"Annual revenue for WPO"}
                    subheader={"(W/o commission)"}
                  />
                  <AccountDataRevenueCard
                    data={`${
                      bundleRevenueData[index]?.totalRevenueIncComUSD
                        ? `USD ${bundleRevenueData[
                            index
                          ]?.totalRevenueIncComUSD?.toLocaleString("en", {
                            useGrouping: true,
                            roundingMode: "trunc",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          })}`
                        : "USD 0.00"
                    }`}
                    header={"USD Total revenue"}
                    subheader={"(Incl. commission)"}
                  />
                  <AccountDataRevenueCard
                    data={`${
                      bundleRevenueData[index]?.annualRevenueWOComUSD
                        ? `
                          USD ${bundleRevenueData[
                            index
                          ]?.annualRevenueWOComUSD?.toLocaleString("en", {
                            useGrouping: true,
                            roundingMode: "trunc",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          })}`
                        : "USD 0.00"
                    }`}
                    header={"USD Annual revenue for WPO"}
                    subheader={"(W/o commission)"}
                  />
                </Box>
              )}
            </AccordionDetails>
          </Accordion>
          {showDialogBox && (
            <ConfirmationDialog
              openDialog={showDialogBox}
              handleOkayClick={removeBundleByIdAndIndex}
              handleCancelClick={closeDialogBox}
              title={Constants.CONFIRM}
              description={Constants.DIALOG_MESSAGE_CONFIRMREMOVEBUNDLE}
            />
          )}
          {showDuplicateDialogBox && (
            <OkayDialog
              openDialog={showDuplicateDialogBox}
              handleOkayClick={handleOkayToDuplicateQuotesInBundle}
              title={Constants.CONFIRM}
              description={Constants.DIALOG_MESSAGE_PROMPTDUPLICATEBUNDLE}
            />
          )}
          {loading && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          {showBundleNotesDialog && getBundleNoteComponent()}
          {showAddBundleNotes && (
            <AddVisualizationBundleNoteDialog
              dialogText={noteText}
              show={showAddBundleNotes}
              title={Constants.NOTEBANNER}
              heading={Constants.NOTEHEADING}
              imgsrc={checkIcon}
              popupType={DialogConstants.NOTE}
              handleTextBoxChange={handleNotesTextChange}
              handleConfirmClick={handleAddBundleNote}
              handleCancelClick={CloseAddBundleNotesDialog}
            />
          )}
        </>
      ))}
    </>
  );
};

export default BundleOptionAccordian;
